import { graphql } from "gatsby";
import * as React from 'react';
export default {
  graphql,
  React
};